// ═══ FIȘĂ TAB ════════════════════════════════════════════════════════════════
// Date personale + secțiunea Medici.
import React, { useState } from "react";
import { fmtD, calcAge, isValidPhone, confirmDelete } from './helpers';
import { BLOOD_TYPES, KINSHIP } from './data';
import { DateField, DatePicker, Dropdown, IconTrash, PhoneInput, SearchableSelect, AddressPicker } from './ui';
import { t } from './i18n';

export function FisaTab({patient,setPatient,editPat,setEditPat,doctors,setDoctors,setModal,onDeleteDoctor,onSavePatient,loadPatientFresh,readOnly=false,initialSub="date",email=""}) {
  const [subTab] = useState(initialSub);
  const sorted = [...(patient.conditions||[])].sort((a,b)=>(b.date||"").localeCompare(a.date||""));
  return (
    <div>
      {subTab==="date"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,gap:8,flexWrap:"wrap"}}>
            <div className="sec" style={{margin:0}}>{t("Date personale")}</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button className="bg" onClick={()=>setModal({type:"exportRaport"})} title={t("Raport PDF cu tratament, analize, consultații și valori pe o perioadă")}>📄 {t("Raport complet")}</button>
              {!readOnly&&<button className="bg" onClick={()=>{if(editPat&&onSavePatient)onSavePatient();setEditPat(e=>!e);}}>{editPat?"✓ "+t("Salvează"):"✎ "+t("Editează")}</button>}
              {!readOnly&&editPat&&<button className="bg" onClick={()=>{loadPatientFresh&&loadPatientFresh();setEditPat(false);}} style={{padding:"7px 12px"}} title={t("Anulează fără salvare")}>✕</button>}
            </div>
          </div>
          <div className="card">
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              {[["Nume complet","name"],["Grupă sanguină","bloodType"],["Alergii","allergies"]].map(([label,key])=>(
                <div key={key}>
                  <div className="lbl">{t(label)}</div>
                  {editPat
                    ? (key==="bloodType"
                        ? <Dropdown value={patient.bloodType||""} onChange={v=>setPatient(p=>({...p,bloodType:v}))} options={BLOOD_TYPES} placeholder={t("— Selectează —")}/>
                        : <input value={patient[key]||""} onChange={e=>setPatient(p=>({...p,[key]:e.target.value}))}/>)
                    : <div style={{fontSize:15}}>{patient[key]||<span style={{color:"var(--border-2)"}}>—</span>}</div>}
                </div>
              ))}
              <div>
                <div className="lbl">{t("Telefon personal")}</div>
                {editPat
                  ?<PhoneInput value={patient.phone||""} onChange={v=>setPatient(p=>({...p,phone:v}))}/>
                  :<div style={{display:"flex",alignItems:"center",gap:6}}>
                    <div style={{fontSize:15}}>{patient.phone||<span style={{color:"var(--border-2)"}}>—</span>}</div>
                    {patient.phone&&!isValidPhone(patient.phone)&&<span style={{fontSize:10,color:"var(--red)"}}>⚠ invalid</span>}
                  </div>}
              </div>
              <div>
                <div className="lbl">{t("Data nașterii")}</div>
                {editPat
                  ? <DatePicker value={patient.dob||""} onChange={val=>setPatient(p=>({...p,dob:val}))}/>
                  : <div style={{fontSize:15}}>{patient.dob||<span style={{color:"var(--border-2)"}}>—</span>}</div>
                }
              </div>
              <div>
                <div className="lbl">{t("Vârstă")}</div>
                <div style={{fontSize:15,fontWeight:400,color:"var(--text)"}}>{calcAge(patient.dob)} <span style={{fontSize:13,color:"var(--text-3)"}}>{t("ani")}</span></div>
              </div>
              <div>
                <div className="lbl">{t("Sex")}</div>
                {editPat
                  ? <div style={{display:"flex",gap:8}}>
                      {[["M",t("Masculin")],["F",t("Feminin")]].map(([v,l])=>(
                        <button key={v} onClick={()=>setPatient(p=>({...p,sex:v}))}
                          style={{flex:1,padding:"7px",border:`1px solid ${patient.sex===v?"#7c3aed":"var(--border-2)"}`,
                            background:patient.sex===v?"var(--blue-bg)":"none",borderRadius:8,color:"var(--text)",
                            cursor:"pointer",fontSize:12,fontFamily:"inherit"}}>
                          {l}
                        </button>
                      ))}
                    </div>
                  : <div style={{fontSize:15}}>{patient.sex==="M"?t("Masculin"):patient.sex==="F"?t("Feminin"):<span style={{color:"var(--border-2)"}}>—</span>}</div>
                }
              </div>
              {editPat
                ? <>
                    <AddressPicker city={patient.city} county={patient.county} onChange={({city,county})=>setPatient(p=>({...p,city,county}))}/>
                    <div>
                      <div className="lbl">{t("Țară")}</div>
                      <input value={patient.country||""} onChange={e=>setPatient(p=>({...p,country:e.target.value}))} placeholder={t("ex: România")}/>
                    </div>
                  </>
                : [["Localitate","city"],["Județ","county"],["Țară","country"]].map(([label,key])=>(
                    <div key={key}>
                      <div className="lbl">{t(label)}</div>
                      <div style={{fontSize:15}}>{patient[key]||<span style={{color:"var(--border-2)"}}>—</span>}</div>
                    </div>
                  ))}
              {email&&(
                <div style={{gridColumn:"1 / -1"}}>
                  <div className="lbl">{t("Email cont")}</div>
                  <div style={{fontSize:15,wordBreak:"break-all"}}>{email}</div>
                </div>
              )}
            </div>
            <div style={{marginTop:14,paddingTop:14,borderTop:"1px solid var(--border)"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <div className="lbl" style={{color:"var(--red)",margin:0}}>⚠ {t("Persoane de urgență")}</div>
                {editPat&&<button className="bg" style={{fontSize:11,padding:"3px 10px"}} onClick={()=>setPatient(p=>({...p,emergencyContacts:[...(p.emergencyContacts||[]),{name:"",phone:""}]}))}>+ {t("Adaugă")}</button>}
              </div>
              {(patient.emergencyContacts||[{name:patient.emergencyName||"",phone:patient.emergencyPhone||""}]).map((ec,i)=>(
                <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10,padding:"10px",background:"var(--bg)",borderRadius:8,border:"1px solid var(--border)",position:"relative"}}>
                  <div>
                    <div className="lbl">{t("Nume")}</div>
                    {editPat
                      ?<input value={ec.name||""} onChange={e=>{const cs=[...(patient.emergencyContacts||[])];cs[i]={...cs[i],name:e.target.value};setPatient(p=>({...p,emergencyContacts:cs}));}} placeholder={t("ex: Ana Ionescu")}/>
                      :<div style={{fontSize:15,fontWeight:600}}>{ec.name||<span style={{color:"var(--border-2)"}}>—</span>}</div>}
                  </div>
                  <div>
                    <div className="lbl">{t("Grad de rudenie")}</div>
                    {editPat
                      ?<SearchableSelect options={KINSHIP} sort={false} value={ec.relation||""} onChange={v=>{const cs=[...(patient.emergencyContacts||[])];cs[i]={...cs[i],relation:v};setPatient(p=>({...p,emergencyContacts:cs}));}} placeholder="—"/>
                      :<div style={{fontSize:14,color:"var(--text-2)"}}>{ec.relation||<span style={{color:"var(--border-2)"}}>—</span>}</div>}
                  </div>
                  <div>
                    <div className="lbl">{t("Telefon")}</div>
                    {editPat
                      ?<PhoneInput value={ec.phone||""} onChange={v=>{const cs=[...(patient.emergencyContacts||[])];cs[i]={...cs[i],phone:v};setPatient(p=>({...p,emergencyContacts:cs}));}}/>
                      :<div style={{display:"flex",alignItems:"center",gap:6}}>
                        <div style={{fontSize:15,fontWeight:600,color:"var(--red)"}}>{ec.phone||<span style={{color:"var(--border-2)"}}>—</span>}</div>
                        {ec.phone&&!isValidPhone(ec.phone)&&<span style={{fontSize:10,color:"var(--red)"}}>⚠ invalid</span>}
                      </div>}
                  </div>
                  {editPat&&(patient.emergencyContacts||[]).length>1&&(
                    <button className="bdel" onClick={()=>confirmDelete(undefined,()=>setPatient(p=>({...p,emergencyContacts:p.emergencyContacts.filter((_,j)=>j!==i)})))} style={{position:"absolute",top:6,right:6}}><IconTrash/></button>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div className="sec" style={{margin:0}}>{t("Diagnostice")}</div>
            {editPat&&<button className="bg" style={{fontSize:12}} onClick={()=>setModal({type:"addCondition"})}>+ {t("Adaugă")}</button>}
          </div>
          <div className="card" style={{padding:"4px 16px"}}>
            {sorted.map((c,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:i<sorted.length-1?"1px solid var(--border)":"none"}}>
                <div style={{width:7,height:7,borderRadius:"50%",background:"var(--blue)",flexShrink:0}}/>
                <div style={{flex:1}}>
                  {editPat?(
                    <div style={{display:"flex",gap:8}}>
                      <input value={c.text} style={{flex:2}} onChange={e=>{const cs=patient.conditions.map(x=>x===c?{...x,text:e.target.value}:x);setPatient(p=>({...p,conditions:cs}));}}/>
                      <DateField value={c.date} style={{flex:1}} onChange={v=>{const cs=patient.conditions.map(x=>x===c?{...x,date:v}:x);setPatient(p=>({...p,conditions:cs}));}}/>
                    </div>
                  ):(
                    <div style={{display:"flex",justifyContent:"space-between"}}>
                      <span style={{fontWeight:600}}>{c.text}</span>
                      <span style={{fontSize:12,color:"var(--text-3)",fontFamily:"monospace"}}>{fmtD(c.date)}</span>
                    </div>
                  )}
                </div>
                {editPat&&<button className="bdel" onClick={()=>confirmDelete(undefined,()=>{
                  const updated={...patient,conditions:patient.conditions.filter(x=>x!==c)};
                  setPatient(updated);
                  if(onSavePatient) onSavePatient(updated);
                })}><IconTrash/></button>}
              </div>
            ))}
            {sorted.length===0&&<div style={{padding:"16px 0",color:"var(--text-4)",textAlign:"center",fontSize:13}}>{t("Niciun diagnostic adăugat.")}</div>}
          </div>
        </div>
      )}
      {subTab==="medici"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div/>
            {!readOnly&&<button className="bp" style={{fontSize:12,padding:"7px 14px"}} onClick={()=>setModal({type:"addDoctor"})}>+ {t("Medic nou")}</button>}
          </div>
          {doctors.map(doc=>(
            <div key={doc.id} className="card">
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6,flexWrap:"wrap"}}>
                    <span style={{fontWeight:700,fontSize:16}}>{doc.name}</span>
                    <span className="pill" style={{background:"var(--blue-bg)",color:"var(--blue-2)"}}>{doc.spec}</span>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                    {doc.hospital&&<div><div className="lbl">{t("Spital/Clinică")}</div><div style={{fontSize:13}}>{doc.hospital}</div></div>}
                    {doc.parafa&&<div><div className="lbl">{t("Parafă")}</div><div style={{fontSize:13,fontFamily:"monospace",color:"var(--text-2)"}}>{doc.parafa}</div></div>}
                    {(doc.phones||[doc.phone]).filter(Boolean).length>0&&(
                      <div><div className="lbl">{t("Telefon")}</div>
                        {(doc.phones||[doc.phone]).filter(Boolean).map((ph,i)=>(
                          <div key={i} style={{fontSize:13,color:"var(--blue)"}}>{ph}</div>
                        ))}
                      </div>
                    )}
                    {doc.address&&<div><div className="lbl">{t("Adresă")}</div><div style={{fontSize:13,color:"var(--text-2)"}}>{doc.address}</div></div>}
                    {doc.email&&<div><div className="lbl">Email</div><div style={{fontSize:13,color:"var(--text-2)"}}>{doc.email}</div></div>}
                    {doc.sharing?.active&&<div style={{gridColumn:"span 2"}}>
                      <div style={{fontSize:11,color:"var(--green)",marginTop:4}}>
                        📤 {t("Partajare activă")} · {Object.entries(doc.sharing).filter(([k,v])=>k!=="active"&&v).map(([k])=>t({fisa:"Acasă",medici:"Medici",documente:"Documente",analize:"Analize",tratament:"Tratament",vaccinuri:"Vaccinuri",familie:"Familie",sumar:"Sumar AI"}[k])).filter(Boolean).join(", ")}
                      </div>
                    </div>}
                  </div>
                  {doc.notes&&<div style={{marginTop:8,fontSize:12,color:"var(--text-3)",fontStyle:"italic"}}>📝 {doc.notes}</div>}
                </div>
                <div style={{display:"flex",gap:6,marginLeft:10,flexShrink:0}}>
                  {!readOnly&&<button className="bg" style={{fontSize:11,padding:"4px 10px"}} onClick={()=>setModal({type:"addDoctor",data:doc})}>✎</button>}
                  {!readOnly&&<button className="bdel" onClick={()=>confirmDelete(undefined,()=>onDeleteDoctor(doc._dbId))}><IconTrash/></button>}
                </div>
              </div>
            </div>
          ))}
          {doctors.length===0&&<div className="card" style={{textAlign:"center",color:"var(--text-4)",padding:"40px 0"}}><div style={{fontSize:36,marginBottom:8}}>🩺</div>{t("Niciun medic adăugat.")}</div>}
        </div>
      )}
    </div>
  );
}
